<!--隐私协议-->
<template>
    <div class="reload-view">
        <div class="top-back">
            <img :src="datainfo.top_img" width="100%" height="200px" alt="情感驿站">
        </div>

        <div class="container">

            <h2>{{ datainfo.title }} </h2>
                <div class="main-list-info-zz">
                    <div class="main-list-info-text">
                        #{{ datainfo.label }}
                    </div>
                    <div class="main-list-info-time">
                        {{ datainfo.create_time }}
                    </div>
                </div>
            <div v-html="datainfo.content" style="margin-top: 50px; min-height: 500px;">
            
            </div>


        </div>
    </div>
    <van-action-bar style="position: static;bottom: 0;">
        <van-action-bar-icon icon="good-job-o" :text="upvote" @click="onClickIcon(datainfo.id)" :color="upvoteColor" :safe-area-inset-bottom="false"/>
        <van-action-bar-button plain type="primary" text="上一篇" @click="onClickNext(upId)" />
        <van-action-bar-button plain type="primary" text="下一篇" @click="onClickNext(nextId)" />
    </van-action-bar>

</template>

<script setup>
import ayzAjax from "@/plugins/axios";
import {useRouter} from "vue-router";
import { ref } from 'vue'
import { showFailToast,showToast } from "vant";
const router = useRouter()

const id = router.currentRoute.value.query.id
// console.log(id)

const datainfo = ref([]);

const isUpvote = ref(false);//是否点赞

const upvoteColor = ref('')//控制颜色切换
const upvote = ref('0');//点赞数

const upId = ref(0);//上一篇id
const nextId = ref(0);//下一篇id

const onClickIcon = async(id) => {
    console.log(id)
    if(isUpvote.value === false){
        const result = await ayzAjax.post('/article_upvote',{id:id})
        console.log(result);
        if(result.data.code !== 200){
            return showFailToast('网络错误');
        }
        isUpvote.value = true
        upvote.value  = (parseInt(upvote.value) + 1).toString()
        upvoteColorChange()
        return showToast('已点赞')
    }
    
    // isUpvote.value = !isUpvote.value
    // if(isUpvote.value === true){
    //     upvoteColor.value = '#C4110C'
    //     upvote.value  = (parseInt(upvote.value) + 1).toString()
    //     showToast('已点赞')
    // }
    // else{
    //     upvoteColor.value = ''
    //     upvote.value  = (parseInt(upvote.value) - 1).toString()
    //     showToast('已取消')
    // }
    
};

const onClickNext = (id)=>{
    if(id > 0){
        router.push({path: '/essaydetail', query: {id:id}}).then(()=>{
            location.reload();
        });
    }else{
        return showToast('没有了')
    }
    
}

ayzAjax.get('/get_article_detail?id=' + id).then((result)=>{
    if(result.data.code !== 200){
        return showFailToast('网络错误');
    }
    console.log(result);
    datainfo.value = result.data.data.data
    upvote.value = result.data.data.data.upvote.toString()
    upId.value = result.data.data.upId
    nextId.value = result.data.data.nextId
    isUpvote.value = result.data.data.isUpvote    
    upvoteColorChange()
})


const upvoteColorChange = ()=>{
    upvoteColor.value = isUpvote.value ? '#C4110C' : '';
}
</script>



<style lang="scss" scoped>

.reload-view{
    background-color: #F6F6F6;
    text-align: left;
    .top-back{
        // background-image: url('~@/assets/essay-back3.jpg');
        // background-size: cover;
        // background-repeat: no-repeat;
        width: 100%;
        height: 200px;
        color: #FFFFFF;
        display: flex;
    }

}
.container{
    margin: 10px 10px 20px 10px;
    padding: 10px;
    background: #fff;
    text-align: left;
    border-radius: 10px;
    .main-list-info-zz {
        margin-left: 10px;
        // width: 100%;
        height: 20px;
        margin-top: 10px;
        .main-list-info-text {
            // width: 80px;
            float: left;
            color: #C9C9C9;
            text-align: left;
            height: 20px;
            line-height: 20px;
        }
        .main-list-info-time {
            margin-left: 85px;
            // float: right;
            // margin-right: 20px;
            // width: 100px;
            color: #C9C9C9;
            text-align: left;
            height: 20px;
            line-height: 20px;
        }
    }
}
p {
    //margin-top: 3px;
    text-indent: 2em;
    line-height: 24px;
    font-size: 15px;
    color: #000000;
    word-break: break-all;
}

.footer{
    display: flex;
    text-align: right;
    float: right;
    p{
        font-size: 16px;
        color: #000000;
        word-break: break-all;
    }
}
</style>
<script setup>
</script>